<template>
  <div>
    <div class="d-flex align-items-center webinars-first-row">
      <h1 class="mb-3">{{$t('Предстоящие вебинары')}} </h1>
      <svg style="display: none">
        <symbol id="webinar-close" width="13" height="14" viewBox="0 0 13 14" fill="none"
                xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L12 13" stroke="#FF3B47" stroke-width="2"/>
          <path d="M12 1L1 13" stroke="#FF3B47" stroke-width="2"/>
        </symbol>
        <symbol id="webinar-edit" width="15" height="16" viewBox="0 0 15 16" fill="none"
                xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12.4833 1.12526C12.2914 1.12526 12.1013 1.16559
                11.924 1.24394C11.7466 1.3223 11.5855 1.43715 11.4497
                 1.58193L2.05443 11.6036L1.27923 14.6355L4.12163
                 13.8086L13.5169 3.78694C13.6527 3.64216 13.7603
                 3.47027 13.8338 3.28111C13.9073 3.09194 13.9451
                 2.88919 13.9451 2.68444C13.9451 2.47968 13.9073
                 2.27693 13.8338 2.08776C13.7603 1.8986 13.6527
                 1.72671 13.5169 1.58193C13.3812 1.43715 13.2201
                 1.3223 13.0427 1.24394C12.8654 1.16559 12.6753
                 1.12526 12.4833 1.12526ZM11.5203 0.20434C11.8256
                  0.0694348 12.1529 0 12.4833 0C12.8138 0 13.1411
                  0.0694348 13.4464 0.20434C13.7518 0.339246 14.0292
                  0.53698 14.2629 0.786253C14.4966 1.03553 14.682 1.33146
                  14.8084 1.65715C14.9349 1.98284 15 2.33191 15 2.68444C15
                  3.03696 14.9349 3.38603 14.8084 3.71172C14.682
                  4.03742 14.4966 4.33335 14.2629 4.58262L4.76852
                  14.7099C4.70362 14.7792 4.62289 14.8291 4.53434
                  14.8549L0.666262 15.9802C0.483647 16.0333 0.288347
                  15.978 0.154503 15.8352C0.0206588 15.6924 -0.0312059
                   15.4841 0.0185981 15.2893L1.07353 11.1634C1.09768
                   11.0689 1.14452 10.9828 1.20943 10.9136L10.7038
                   0.786253C10.9375 0.53698 11.2149 0.339246 11.5203
                   0.20434Z"
                fill="black"/>
        </symbol>
      </svg>
    </div>
    <Webinar
        v-for="webinar in webinars"
        :id="webinar.id"
        :key="webinar.id"
        :webinar="webinar"
        :end-webinar="endUpWebinar"
        :start-webinar="beginWebinar"
        @cancelWebinar="onWebinarCancelling"
        @openWebinarChangeModal="openChangeWebinar"
    />
    <changeWebinarTime :webinar="activeWebinar" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Webinar from '@/components/Webinar';
import changeWebinarTime from "@/components/Modals/changeWebinarTime";

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('teacher');


export default {
  name: 'teacherSchedule',
  components: {
    Webinar,
    changeWebinarTime
  },
  data() {
    return {
      activeWebinar: null,
    }
  },
  computed: {
    ...mapState({
      webinars: (state) => state.myUpcomingWebinars,
    }),
  },
  methods: {
    ...mapActions(['getWebinars', 'startWebinar', 'endWebinar', 'changeWebinar']),
    openChangeWebinar(webinarId) {
      this.activeWebinar = this.webinars.find(webinar => webinar.id === webinarId);
      this.$root.$emit('bv::show::modal', 'editChangeTime');
    },
    onWebinarCancelling(id) {
      this.$bvModal
          .msgBoxConfirm('Пожалуйста, подтвердите, что вы хотите отменить вебинар', {
            title: 'Подтверждение',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Да',
            cancelTitle: 'Нет',
            cancelVariant: 'primary',
            hideHeaderClose: false,
            centered: true,
          })
      .then(res => {
        if (res) {
          this.changeWebinar({
            status: 3,
            id: +id,
          })
        }
      })
    },
    beginWebinar(id) {
      this.startWebinar(id)
          .then(() => {
            this.$toast.success(this.$t('Вебинар успешно начат, перейдите в зум и начинайте преподавать!'));
            const { link } = this.webinars.find((webinar) => webinar.id === id);
            window.open(link);
          })
          .catch(() => {
            this.$toast.error(this.$t('Упс! Что-то пошло не так. Свяжитесь с администратором!'));
          });
    },
    endUpWebinar(id) {
      this.endWebinar(id)
          .then(() => {
            this.$toast.success(this.$t('Вебинар успешно завершен. Спасибо за проведенный урок'));
          })
          .catch(() => {
            this.$toast.error(this.$t('Упс! Что-то пошло не так. Свяжитесь с администратором!'));
          });
    },
  },
  created() {
    this.getWebinars();
  },
};
</script>

<style scoped>

</style>
